<template>
  <div>
    <div v-for="(iconItem, index) in iconData" :key="index">
        <p :style="{ color: 'var(--textColor)' }">{{ iconItem.name }}</p>
        <div class="fill_icon_box">
          <div v-for="(className, index) in iconItem.data" class="swpier_botton_icon_box" :key="index">
                <span
                    @click="changeIconClassName(className)"
                    :class="[
                    className,
                    'swpier_botton_icon',
                    selectedIcon === className && 'active_swiper_button'
                  ]"
                    :style="{
                    '--color': request_prefix.toLowerCase().includes('stage')
                      ? 'rgba(0, 0, 0, 0.8)'
                      : 'rgba(255, 255, 255, 0.4)'
                  }"
                ></span>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  name:"icon-select",
  props: {
    options: {
      type: Object
    },
    ids: {
      type: Object
    },
    selectedIcon:{
      type: null
    }
  },
  data() {
    return {
      iconData: [
        {
          name: "填充图标",
          data: [
            "icon-portal-circle-arrow-fill1",
            "icon-portal-circle-arrow-fill2",
            "icon-portal-circle-double-arrow-fill",
            "icon-portal-square-arrow-fill2",
            "icon-portal-cartoon-arrow"
          ]
        },
        {
          name: "线性图标",
          data: [
            "icon-portal-arrow1",
            "icon-portal-circle-arrow-empty1",
            "icon-portal-circle-arrow-empty2",
            "icon-portal-line-arrow4",
            "icon-portal-line-arrow3",
            "icon-portal-double-line-arrow",
            "icon-portal-line-arrow2",
            "icon-portal-line-arrow1"
          ]
        }
      ],
    }
  },
  computed: {
    swiperButtonType: {
      get() {
        return this.options.swiperButtonType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "swiperButtonType", false, null, this.getRectId)
      }
    },
    showButton: {
      get() {
        return this.options.showButton
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showButton", false, null, this.getRectId)
      }
    },
    buttonIconSize: {
      get() {
        return this.options.buttonIconSize
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "buttonIconSize", false, null, this.getRectId)
      }
    },
    buttonIconColor: {
      get() {
        return this.options.buttonIconColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "buttonIconColor", false, null, this.getRectId)
      }
    }
  },
  methods:{
    changeIconClassName(name){
      this.$emit("update:selectedIcon",name)
    }
  }
}
</script>

<style scoped>
.fill_icon_box {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
}
.swpier_botton_icon_box {
  width: 25%;
  text-align: center;
  font-size: 21px;
  padding: 9.5px;
}

.swpier_botton_icon::before {
  color: var(--color);
}
.swpier_botton_icon:hover {
  cursor: pointer;
  padding: 9.5px;
  border: 1px solid var(--themeColor);
  border-radius: 4px;
}
/*.active_swiper_button {*/
/*  padding: 9.5px;*/
/*  border: 1px solid var(--themeColor);*/
/*  border-radius: 4px;*/
/*}*/
</style>
